import { render, staticRenderFns } from "./TaxConfigurationGroupList.vue?vue&type=template&id=d12444d8&"
import script from "./TaxConfigurationGroupList.vue?vue&type=script&lang=js&"
export * from "./TaxConfigurationGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d12444d8')) {
      api.createRecord('d12444d8', component.options)
    } else {
      api.reload('d12444d8', component.options)
    }
    module.hot.accept("./TaxConfigurationGroupList.vue?vue&type=template&id=d12444d8&", function () {
      api.rerender('d12444d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/invoice/parameters/TaxConfigurationGroupList.vue"
export default component.exports